var WorkflowItemStatus;
(function (WorkflowItemStatus) {
    WorkflowItemStatus["PENDING"] = "pending";
    /**
     * Indicates the remainder of the workflow should be skipped
     *
     * If a workflow item is set to failed, the workflow will optionally resort to
     * a failure workflow context as instructed by the workflow’s parent.
     */
    WorkflowItemStatus["FAILED"] = "failed";
    WorkflowItemStatus["COMPLETE"] = "complete";
})(WorkflowItemStatus || (WorkflowItemStatus = {}));
var WorkflowInlineComponentName;
(function (WorkflowInlineComponentName) {
    WorkflowInlineComponentName["GO_TO_PATIENT"] = "GoToPatient";
    WorkflowInlineComponentName["TODO"] = "TestModalComp";
    WorkflowInlineComponentName["SAMPLE_CHARTING"] = "sample-charting";
    /** @deprecated - now we use WorkflowModalComponentName.CONFIRM_DEPARTURE */
    WorkflowInlineComponentName["START_TRANSIT"] = "StartTransit";
})(WorkflowInlineComponentName || (WorkflowInlineComponentName = {}));
/** Styled in kebab-case for use in router paths */
var WorkflowModalComponentName;
(function (WorkflowModalComponentName) {
    WorkflowModalComponentName["ID_CARD"] = "id-card";
    WorkflowModalComponentName["PATIENT_DOB"] = "patient-dob";
    WorkflowModalComponentName["FILL_OUT_LABELS"] = "fill-out-labels";
    WorkflowModalComponentName["PATIENT_CONSENT"] = "patient-consent";
    WorkflowModalComponentName["FOLLOW_KIT_INSTRUCTIONS"] = "follow-kit-instructions";
    WorkflowModalComponentName["PROCEDURE_CHARTING"] = "procedure-charting";
    WorkflowModalComponentName["DROP_OFF_LAB_ORDER"] = "drop-off-lab-order";
    WorkflowModalComponentName["PROCEDURE_INSTRUCTIONS"] = "procedure-instructions";
    /** General purpose, to be used for any workflow item that requires a scanner */
    WorkflowModalComponentName["SCANNER"] = "scanner";
    WorkflowModalComponentName["CONFIRM_DEPARTURE"] = "confirm-departure";
    WorkflowModalComponentName["EMBED"] = "embed";
})(WorkflowModalComponentName || (WorkflowModalComponentName = {}));
/**
 * List of components that can be opened by a footer button variant of type
 * WorkflowItemModalButtonAction.OPEN_MODAL
 */
var FooterOpenModalComponentName;
(function (FooterOpenModalComponentName) {
    FooterOpenModalComponentName["CHARTING_TUBE_LABELS"] = "charting-tube-labels";
})(FooterOpenModalComponentName || (FooterOpenModalComponentName = {}));
/**
 * Button actions that can be done by those in the modal footer
 */
var WorkflowItemModalButtonAction;
(function (WorkflowItemModalButtonAction) {
    WorkflowItemModalButtonAction["COMPLETE"] = "complete";
    WorkflowItemModalButtonAction["CLOSE"] = "close";
    WorkflowItemModalButtonAction["FAIL"] = "fail";
    WorkflowItemModalButtonAction["OPEN_MODAL"] = "openModal";
    /**
     * Special action that will trigger a function exposed by the modal component
     * associated with the workflow item. A cheeky way to be able to trigger
     * component-specific actions from the modal footer - which is otherwise
     * inaccessible.
     *
     * This function must be exposed by the modal component itself and titled `exposedAction`.
     *
     * Return `true` if the workflow item should succeed, `false` if it should fail.
     * Return `undefined` if the workflow item shouldn't do anything regarding workflow item completion
     */
    WorkflowItemModalButtonAction["TRIGGER_EXPOSED_ACTION"] = "triggerExposedAction";
})(WorkflowItemModalButtonAction || (WorkflowItemModalButtonAction = {}));

export { FooterOpenModalComponentName, WorkflowInlineComponentName, WorkflowItemModalButtonAction, WorkflowItemStatus, WorkflowModalComponentName };
